import request from '@/utils/request';

export function downloadProjectJson(projectID) {
  return request({
    method: 'get',
    url: `hema-pending-project/${projectID}`
  });
}

export function processPendingProject(command) {
  return request({
    method: 'post',
    url: 'hema-pending-project',
    data: command
  });
}

export const storeExtensions = {
  actions: {
    downloadProjectJson({ dispatch }, { projectID }) {
      return new Promise((resolve, reject) =>
        downloadProjectJson(projectID)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },

    processPendingProject({ dispatch }, command) {
      return new Promise((resolve, reject) =>
        processPendingProject(command)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
